import { ref, onMounted, onUnmounted } from 'vue';
import { MOBILE_MAX_WIDTH, TABLET_MAX_WIDTH } from '~/constants/device';

export function useDevice() {
  const isPc = ref(true);
  const isMobile = ref(false);
  const isTablet = ref(false);

  // デバイスタイプを判定する関数
  const checkDeviceType = () => {
    if (typeof window === 'undefined') {
      return;
    }

    const width = window.innerWidth;
    isPc.value = width > TABLET_MAX_WIDTH;
    isTablet.value = width <= TABLET_MAX_WIDTH && width > MOBILE_MAX_WIDTH;
    isMobile.value = width <= MOBILE_MAX_WIDTH;
  };

  // ブラウザ環境のみで実行するガード
  const setupDeviceDetection = () => {
    if (typeof window === 'undefined') {
      return;
    }

    // 初期チェック
    checkDeviceType();

    // リサイズイベントでデバイスタイプを再判定
    window.addEventListener('resize', checkDeviceType);

    // クリーンアップ
    onUnmounted(() => {
      window.removeEventListener('resize', checkDeviceType);
    });
  };

  // クライアントサイドでのみ実行
  onMounted(setupDeviceDetection);

  // ユーザーエージェント判定（オプション機能）
  const isIOSDevice = () => {
    if (typeof navigator === 'undefined') {
      return false;
    }
    // TypeScriptエラーを修正（MSStreamのチェックを削除）
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  };

  const isAndroidDevice = () => {
    if (typeof navigator === 'undefined') {
      return false;
    }
    return /Android/.test(navigator.userAgent);
  };

  // Safariの判定を追加（オプション）
  const isSafari = () => {
    if (typeof navigator === 'undefined') {
      return false;
    }
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };

  return {
    isPc,
    isMobile,
    isTablet,
    isIOSDevice,
    isAndroidDevice,
    isSafari,
  };
}
